import React from 'react';

import { usePlayContentId } from '@/scenarios/legacy-player/components/feature-player/hooks/player-instance/use-play-content-id';
import { useInstanceCallback } from '@/scenarios/legacy-player/hooks/useInstanceCallback';

import { usePlayingContentId } from '../../hooks/use-playing-content-id';
import { ContentType } from '../../types';

import { PlayerManager } from './component';

interface Props {
    contentId: string;
    onClose: () => void;
    isLoading: boolean;
    contentType: ContentType | undefined;
}

export const PlayerManagerContainer = ({ contentId, onClose, isLoading, contentType }: Props) => {
    // ToDo remove choice OTT-67879
    const playingContentId = usePlayingContentId() || contentId;

    const handleClose = useInstanceCallback(
        (instance) => {
            if (instance?.type === 'filmoscope') {
                instance.pureInstance.stop();
            } else if (instance?.type === 'ya') {
                instance.pureInstance.pause();
            }
            onClose?.();
        },
        [onClose]
    );

    usePlayContentId(playingContentId);

    return (
        <PlayerManager
            onClose={handleClose}
            contentId={playingContentId}
            contentType={contentType}
            isLoading={isLoading}
        />
    );
};
